import axios from '../../axios/base'
import moment from 'moment'
import { saveFileFromResponse } from '../../helpers'
import {
  FETCH_FEEDBACK_EMP_FAILED,
  FETCH_FEEDBACK_EMP_START,
  FETCH_FEEDBACK_EMP_SUCCESS,
  FETCH_FEEDBACK_STRUCTURE_START,
  FETCH_FEEDBACK_STRUCTURE_SUCCESS,
  FETCH_FEEDBACK_STRUCTURE_FAILED,
  FETCH_FEEDBACK_HISTORY_START,
  FETCH_FEEDBACK_HISTORY_SUCCESS,
  FETCH_FEEDBACK_HISTORY_FAILED,
  POST_FEEDBACK_HISTORY_START,
  POST_FEEDBACK_HISTORY_SUCCESS,
  POST_FEEDBACK_HISTORY_FAILED,
  SET_FEEDBACK_READ_STATE
} from './actionTypes'
import { enqueueSnackbar } from './alert'

export const fetchFeedbackEmp = filterOptions => {
  const params = filterOptions
  return async dispatch => {
    dispatch(fetchFeedbackEmpStart())
    try {
      const response = await axios.get('/feedback/emp_list', { params })
      if (response.status === 200) {
        const availableEmps = response.data.data
        dispatch(fetchFeedbackEmpSuccess(availableEmps, filterOptions))
      }
    } catch (err) {
      dispatch(fetchFeedbackEmpFailed())
      dispatch(
        enqueueSnackbar({
          message: 'Fetch Feedback Emp Error',
          options: {
            variant: 'error'
          }
        })
      )
    }
  }
}

export const fetchFeedbackStructure = user => {
  // const params = filterOptions
  return async (dispatch, getState) => {
    const state = getState()
    const selectedEmpId = state.feedback.currentFilter.emp_id
    let params = {}
    if (selectedEmpId) {
      params = { selectedEmpId }
    }
    params = { ...params, receiver: user?.emp_detail_id || null }
    dispatch(fetchFeedbackStructureStart())
    try {
      const response = await axios.get(`/feedback/structure_list/${user.result_id}`, {
        params
      })
      if (response.status === 200) {
        const availableStructures = response.data.data
        dispatch(fetchFeedbackStructureSuccess(availableStructures, user))
      }
    } catch (err) {
      dispatch(fetchFeedbackStructureFailed())
      dispatch(
        enqueueSnackbar({
          message: 'Fetch Feedback Structure Error',
          options: {
            variant: 'error'
          }
        })
      )
    }
  }
}

export const fetchFeedbackHistory = (resultItemId, user, currentLength) => {
  return async (dispatch, getState) => {
    const state = getState()
    const selectedEmpId = state.feedback.currentFilter.emp_id
    const feedbackEmps = state.feedback.feedbackEmps ?? []
    const self = feedbackEmps.find(item => item.is_self)
    const selfEmpDetailId = self?.emp_detail_id

    let params = { currentLength, selfEmpDetailId }
    if (selectedEmpId) {
      params = { ...params, selectedEmpId }
    }
    params = { ...params, receiver: user?.emp_detail_id || null }
    dispatch(fetchFeedbackHistoryStart())
    dispatch(setFeedbackReadState(resultItemId))
    try {
      const response = await axios.get(`/feedback/history/${resultItemId}`, {
        params
      })
      if (response.status === 200) {
        const chatHistory = response.data.data
        dispatch(fetchFeedbackHistorySuccess(chatHistory, resultItemId))
      }
    } catch (err) {
      dispatch(fetchFeedbackHistoryFailed())
      dispatch(
        enqueueSnackbar({
          message: 'Fetch Feedback Structure Error',
          options: {
            variant: 'error'
          }
        })
      )
    }
  }
}

export const postFeedback = (payload, user) => {
  return async (dispatch, getState) => {
    const state = getState()
    const chatHistory = state.feedback.feedbackHistory
    const resultItemId = state.feedback.currentHistoryId
    const toEmpDetailId = state.feedback.currentUser.emp_detail_id
    const feedbackEmps = state.feedback.feedbackEmps ?? []
    const { full_name, img_path } = state.auth.user.employee
    let file = null
    if (payload.file) {
      file = {
        file_name: payload.file.name,
        file_type: 'other'
      }
    }

    const draftHistory = {
      ...payload,
      feedback_id: 'draft',
      is_owner: 1,
      sender: { full_name, img_path },
      file,
      send_at: moment().format('YYYY-MM-DD kk:mm:ss.SSS')
    }
    const updatedChatHistory = [...chatHistory, draftHistory]
    dispatch(postFeedbackStart(updatedChatHistory))

    try {
      const self = feedbackEmps.find(item => item.is_self)
      const selfEmpDetailId = self?.emp_detail_id
      const formData = new FormData()
      formData.append('message', payload.message)
      formData.append('file', payload.file)
      formData.append('self_emp_detail_id', selfEmpDetailId)
      formData.append('emp_detail_id', toEmpDetailId)

      const response = await axios.post(`/feedback/history/${resultItemId}`, formData)
      if (response.status === 200) {
        dispatch(postFeedbackSuccess())
        dispatch(fetchFeedbackHistory(resultItemId, user, 0))
      }
    } catch (err) {
      dispatch(postFeedbackFailed())
      dispatch(
        enqueueSnackbar({
          message: 'Post Feedback Error',
          options: {
            variant: 'error'
          }
        })
      )
    }
  }
}

export const downloadFeedbackAttachment = feedbackHistoryId => {
  return async dispatch => {
    // console.log(`download attachment for history id: ${feedbackHistoryId}`)
    const response = await axios.get(`feedback/${feedbackHistoryId}/file`, { responseType: 'blob' })
    saveFileFromResponse(response)
  }
}

export const setFeedbackReadState = resultItemId => ({
  type: SET_FEEDBACK_READ_STATE,
  resultItemId
})

const postFeedbackStart = chatHistory => {
  return {
    type: POST_FEEDBACK_HISTORY_START,
    chatHistory
  }
}

const postFeedbackSuccess = () => {
  return {
    type: POST_FEEDBACK_HISTORY_SUCCESS
  }
}

const postFeedbackFailed = () => {
  return {
    type: POST_FEEDBACK_HISTORY_FAILED
  }
}

const fetchFeedbackHistoryStart = () => {
  return {
    type: FETCH_FEEDBACK_HISTORY_START
  }
}

const fetchFeedbackHistorySuccess = (chatHistory, resultId) => {
  return {
    type: FETCH_FEEDBACK_HISTORY_SUCCESS,
    chatHistory,
    resultId
  }
}

const fetchFeedbackHistoryFailed = () => {
  return {
    type: FETCH_FEEDBACK_HISTORY_FAILED
  }
}

const fetchFeedbackEmpStart = () => {
  return {
    type: FETCH_FEEDBACK_EMP_START
  }
}

const fetchFeedbackEmpSuccess = (data, filter) => {
  return {
    type: FETCH_FEEDBACK_EMP_SUCCESS,
    data,
    filter
  }
}

const fetchFeedbackEmpFailed = () => {
  return {
    type: FETCH_FEEDBACK_EMP_FAILED
  }
}

const fetchFeedbackStructureStart = () => {
  return {
    type: FETCH_FEEDBACK_STRUCTURE_START
  }
}

const fetchFeedbackStructureSuccess = (data, user) => {
  return {
    type: FETCH_FEEDBACK_STRUCTURE_SUCCESS,
    data,
    user
  }
}

const fetchFeedbackStructureFailed = () => {
  return {
    type: FETCH_FEEDBACK_STRUCTURE_FAILED
  }
}
